import React from 'react';
import PropTypes from 'prop-types';

class FlowContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      position: 0,
    };
  }

  getStepFlow() {
    const forward = () => {
      const { position, } = this.state;
      const { chain, } = this.props;
      let value = position + 1;
      if (value > chain.length) {
        value = chain.length;
      }

      this.setState({
        position: value,
      });
    };

    const back = () => {
      const { position, } = this.state;
      let value = position - 1;
      if (value < 0) {
        value = 0;
      }
      this.setState({
        position: value,
      });
    };

    const reset = () => {
      this.setState({
        position: 0,
      });
    };

    return {
      forward,
      back,
      reset,
    };
  }

  render() {
    const { chain, } = this.props;
    const { position, } = this.state;
    return chain[position].component(this.getStepFlow());
  }
}

FlowContainer.propTypes = {
  chain: PropTypes.array.isRequired,
};

export default FlowContainer;
